export default __webpack_public_path__ + "static/media/404.e3d02d0b.svg";